import { useId } from 'react'

import { EMPTY_STRING } from '../../../../constants/common'

export function useAIButtonIconGradientId(prefix) {
  return `${prefix}-${useId().replace(/:/g, EMPTY_STRING)}`
}
